__turbopack_context__.v({
  "form": "PlasmicHomeLoginSection-module__sYO4Wa__form",
  "icon": "PlasmicHomeLoginSection-module__sYO4Wa__icon",
  "img": "PlasmicHomeLoginSection-module__sYO4Wa__img",
  "link": "PlasmicHomeLoginSection-module__sYO4Wa__link",
  "logInButton": "PlasmicHomeLoginSection-module__sYO4Wa__logInButton",
  "login": "PlasmicHomeLoginSection-module__sYO4Wa__login",
  "loginForm": "PlasmicHomeLoginSection-module__sYO4Wa__loginForm",
  "loginSection": "PlasmicHomeLoginSection-module__sYO4Wa__loginSection",
  "multiFactorAuthModal": "PlasmicHomeLoginSection-module__sYO4Wa__multiFactorAuthModal",
  "passwordInput": "PlasmicHomeLoginSection-module__sYO4Wa__passwordInput",
  "passwordProvider": "PlasmicHomeLoginSection-module__sYO4Wa__passwordProvider",
  "spinnerIcon": "PlasmicHomeLoginSection-module__sYO4Wa__spinnerIcon",
  "svg__jxvgR": "PlasmicHomeLoginSection-module__sYO4Wa__svg__jxvgR",
  "svg__xiAoZ": "PlasmicHomeLoginSection-module__sYO4Wa__svg__xiAoZ",
  "text": "PlasmicHomeLoginSection-module__sYO4Wa__text",
  "text__e26Lb": "PlasmicHomeLoginSection-module__sYO4Wa__text__e26Lb",
  "title": "PlasmicHomeLoginSection-module__sYO4Wa__title",
  "usernameInput": "PlasmicHomeLoginSection-module__sYO4Wa__usernameInput",
  "usernameProvider": "PlasmicHomeLoginSection-module__sYO4Wa__usernameProvider",
  "warning": "PlasmicHomeLoginSection-module__sYO4Wa__warning",
  "wrapper": "PlasmicHomeLoginSection-module__sYO4Wa__wrapper",
  "wrapper2": "PlasmicHomeLoginSection-module__sYO4Wa__wrapper2",
  "wrapper3": "PlasmicHomeLoginSection-module__sYO4Wa__wrapper3",
  "wrapper4": "PlasmicHomeLoginSection-module__sYO4Wa__wrapper4",
});
